export const defaultSidebarItems = [
  {
    label: 'Home',
    icon: 'home-heart',
  },
  {
    label: 'Action Items',
    icon: 'check-circle',
  },
  {
    label: 'Quick Search...',
    icon: 'search',
  },
];
